import Buefy from 'buefy'
import moment from 'moment'
import VeeValidate, { Validator } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import Vue from 'vue'
import VueClip from 'vue-clip'
import VueCookie from 'vue-cookie'
import VueMoment from 'vue-moment'
import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import { store } from './store'
import CnpjValidator from './validators/cnpj.validator'

import { C } from './constante'

import PortalVueComponents from './portal-vue-components'

Vue.use(Buefy, {defaultDateFormatter: date => date.toLocaleDateString('pt-BR')})
Vue.use(VueClip)
Vue.use(VueResource)
Vue.use(VueCookie)
Vue.use(VueMoment, {moment})

Validator.localize({ pt_BR: ptBR })
Validator.extend('cnpj', CnpjValidator)
Vue.use(VeeValidate, {locale: 'pt_BR', errorBagName: 'errors', delay: 5})
moment.locale('pt-BR')

Vue.config.productionTip = false

var options = {
  nome: 'PILLER',
  icone: 'chart-line',
  cookie: VueCookie,
  router: router,
  constantes: C,
  tempo: '300h',
  versao: '3.4.0',
  perfil: 'Produção',
  // perfil: 'Desenvolvimento',
  dominio: 'piller.binconsultoria.com.br'
  // dominio: 'localhost'
}

Vue.use(PortalVueComponents, options)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

// ARQUIVOS QUE PRECISAM SER ALTERADOS PARA CADA EMPRESA
// main.js
// constante.js
// assets/style.scss
// config/index.js



// WEBPACK FOOTER //
// ./src/main.js